import { reducer as httpRequestReducer } from '@travel/http-request';
import { reducer as i18nReducer } from '@travel/i18n';

import { routerReducer } from './__router/slice';
import { authCodeReducer } from './authCode/slice';
import { commonErrorReducer } from './commonError/slice';
import { searchVacantReducer } from './searchVacant/slice';
import { userAgentReducer } from './userAgent/slice';

import { combineReducers } from '@reduxjs/toolkit';

export default combineReducers({
  _i18n: i18nReducer,
  _httpRequest: httpRequestReducer,
  router: routerReducer,
  authCode: authCodeReducer,
  commonError: commonErrorReducer,
  userAgent: userAgentReducer,
  searchVacant: searchVacantReducer,
});
